'use client'

const CDN_START = "https://d363r49np5tk98.cloudfront.net/"

export default function cloudfrontLoader({ src, width, quality }) {
  const isCDN = src.includes(CDN_START);

  if (isCDN) {
    const url = new URL(`${CDN_START}${src.replace(CDN_START, "")}`)
    url.searchParams.set('format', 'auto')
    url.searchParams.set('width', width.toString())
    url.searchParams.set('quality', (quality || 75).toString())
    return url.href
  }
  return src;
}